/** Work Queue route helpers (V1: inbox split only). */
export const WORK_QUEUE_PATHS = {
  root: '/work-queues',
  event: (eventId) => `/work-queues/${eventId}`,
  activity: '/work-queues/activity',
};

/** True when Work Queue tab content is showing (inbox split). */
export function isWorkQueuePath(pathname = '') {
  if (!pathname.startsWith('/work-queues')) return false;
  if (pathname.startsWith(WORK_QUEUE_PATHS.activity)) return false;
  if (pathname.startsWith('/work-queues/event/')) return false;
  if (pathname.startsWith('/work-queues/inbox')) return false;
  return true;
}
